export const SET_POSITIONS = 'SET_POSITIONS';
export const SET_POSITION = 'SET_POSITION';
export const ADD_POSITION = 'ADD_POSITION';
export const UPDATE_POSITION = 'UPDATE_POSITION';
export const REMOVE_POSITION = 'REMOVE_POSITION';
export const CLEAR_POSITION = 'CLEAR_POSITION';
export const CLEAR_POSITIONS = 'CLEAR_POSITIONS';
